<template>
    <div class="privacy-policy p-4">
        <v-img max-height="150" max-width="200" src="./PICphone.png"></v-img>

        <p>
            Our application is designed to support seniors by allowing emergency calls to specific contacts
            and facilitating communication with a designated aidant (caregiver). We value the privacy and
            safety of all users, especially seniors, and are committed to protecting your personal data.
        </p>

        <h3 class="font-bold mt-4">Information We Collect</h3>
        <ul class="list-disc ml-6">
            <li><strong>Personal Data</strong>: Name, phone number, and contact list (only those required for emergency
                use).</li>
            <li><strong>Communication Data</strong>: Messages exchanged between the senior and the aidant.</li>
            <li><strong>Usage Data</strong>: App usage information for improving functionality (e.g., when emergency
                calls are made).</li>
        </ul>

        <h3 class="font-bold mt-4">How We Use Your Data</h3>
        <ul class="list-disc ml-6">
            <li>To enable emergency calls to pre-selected contacts.</li>
            <li>To allow secure chat communication between the senior and the aidant.</li>
            <li>To monitor app functionality and ensure reliability.</li>
        </ul>

        <h3 class="font-bold mt-4">Data Sharing</h3>
        <ul class="list-disc ml-6">
            <li>We do <strong>not</strong> share your personal data with third parties.</li>
            <li>Contacts and messages are <strong>only accessible</strong> to the senior and their assigned aidant.</li>
        </ul>

        <h3 class="font-bold mt-4">Data Security</h3>
        <ul class="list-disc ml-6">
            <li>All communications are encrypted.</li>
            <li>Access is restricted to authorized users only.</li>
            <li>Emergency features are protected to prevent misuse.</li>
        </ul>

        <h3 class="font-bold mt-4">Your Rights</h3>
        <ul class="list-disc ml-6">
            <li>Seniors and aidants can request access, correction, or deletion of their data.</li>
            <li>You may revoke app permissions at any time through device settings.</li>
        </ul>

        <h3 class="font-bold mt-4">Compliance</h3>
        <p>Our app complies with applicable privacy regulations such as the GDPR.</p>
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicy',
    mounted() {
        document.title = "PicPhone - Privacy policy";

        const favicon = document.querySelector("link[rel~='icon']");
        if (favicon) {
            favicon.href = "/PicPhone.ico";
        } else {
            const newFavicon = document.createElement("link");
            newFavicon.rel = "icon";
            newFavicon.href = "PicPhone.ico";
            document.head.appendChild(newFavicon);
        }
    },

    unmounted() {
        const favicon = document.querySelector("link[rel~='icon']");
        if (favicon) {
            favicon.href = "/favicon.ico";
        }
    }
};
</script>

<style scoped>
.privacy-policy {
    /* max-width: 800px; */
    margin: auto;
    font-size: 1rem;
    line-height: 1.6;
    text-align: start;
}
</style>